import { render } from "./free-actions.vue?vue&type=template&id=c9e52204&lang=pug"
import script from "./free-actions.vue?vue&type=script&lang=js"
export * from "./free-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__